import { Link } from '@reach/router';
import styled from 'styled-components/macro';
import {
  focusRing,
  fontSize,
  lineHeight,
  neutral,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import { StaffSubHeader } from '../../common/elements/Staff';

export const PolicyLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  border-radius: ${radius.md};
  ${focusRing}
`;

export const PolicyInfo = styled(StaffSubHeader)`
  padding: 0;
`;

export const PolicyText = styled.p`
  font-size: ${fontSize.md};
  line-height: ${lineHeight.normal};
`;

export const PolicyCard = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  margin: 0 0 ${space[4]};
  padding: ${space[4]};
  border: 1px solid ${neutral.border};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.sm};
  background: ${neutral.surface};
`;

export const PolicyTopRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${space[3]};
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${space[3]};
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
